export enum VoiceAccess {
    Public = 'public',
    Premium = 'premium',
    Private = 'private',
    ExternalPrivate = 'external-private',
}

export enum Providers {
    Amazon = 'amazon',
    Microsoft = 'microsoft',
    AzureOpenAi = 'azure-openai',
    Afflorithmics = 'afflorithmics',
    Elevenlabs = 'elevenlabs',
    Google = 'google',
}

export interface VoiceLanguage {
    language: string;
    locale: string;
    accent?: string;
    config?: any;
    previewUrl?: string;
}

export interface IApiVoice {
    id: string;
    name: string;
    gender: string;
    access: VoiceAccess;
    provider: Providers;
    languages: VoiceLanguage[];
    styles: string[];
    description?: string;
    age?: string;
    useCase?: string;
    isLegacy?: boolean;
}

export interface IVoice {
    id: string;
    name: string;
    gender: string;
    locale: string;
    access: VoiceAccess;
    provider: Providers;
    styles: string[];
    language: string;
    accent?: string;
    description?: string;
    age?: string;
    useCase?: string;
    isLegacy?: boolean;
    previewUrl?: string;
    config?: {
        modelId?: string;
        availableModels?: string[];
    };
    voiceType?: 'Avatar' | 'CloneVoice' | 'Injected';
    deprecationMessage?: string;
}

export type ApiVoicesResponse = (IApiVoice | IVoice)[];

export interface StreamTextToSpeechVoice {
    type: Providers;
    voice_id: string;
    voice_config?: string;
    access?: VoiceAccess;
    language?: string;
}
